import { render, staticRenderFns } from "./PayrollRunShow.vue?vue&type=template&id=52e87012"
import script from "./PayrollRunShow.vue?vue&type=script&lang=js"
export * from "./PayrollRunShow.vue?vue&type=script&lang=js"
import style0 from "./PayrollRunShow.vue?vue&type=style&index=0&id=52e87012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports